import { EnumInstituicao } from "model/enums/enum-instituicao";
import { EnumTipoPessoas } from "model/enums/enum-tipo-pessoas";
import { EnumTipoTaxa } from "model/enums/enum-tipo-taxa";

export class PessoaTaxaModel {
    constructor(
      public id: string = '',
      public credencialId: string = '',
      public pessoaId: string = '',
      public pessoaNome: string = '',
      public tipoPessoa: EnumTipoPessoas = EnumTipoPessoas.Cliente,
      public tipoTransacao: number = 2,
      public instituicaoFinanceira: EnumInstituicao = EnumInstituicao.Safra,
      public tipoTaxa: EnumTipoTaxa = EnumTipoTaxa.CUSTO,
      public percentual: number = 0,
      public valorMinimo: number = 0,
      public valorMaximo: number = 0,
      public s2PayEcId: string | null = null,
      public s2PayEcRetorno: string | null = null,
      public s2PayEcDataRegistro: string | null = null,
    ) {}
  }  